const appBaseUrl = (import.meta.env.VITE_APP_URL as string | undefined)?.replace(/\/$/, "");

function localOrAbsolute(path: string) {
  if (!appBaseUrl) {
    return path;
  }

  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${appBaseUrl}${normalized}`;
}

export const appLinks = {
  workspaces: localOrAbsolute("/workspaces"),
  login: localOrAbsolute("/login"),
  terms: localOrAbsolute("/terms"),
  privacy: localOrAbsolute("/privacy"),
  support: "mailto:support@venturebuilders.com",
} as const;
